import { render, staticRenderFns } from "./planListNew.vue?vue&type=template&id=5512c895&scoped=true"
import script from "./planListNew.vue?vue&type=script&lang=js"
export * from "./planListNew.vue?vue&type=script&lang=js"
import style0 from "./planListNew.vue?vue&type=style&index=0&id=5512c895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5512c895",
  null
  
)

export default component.exports